import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { exportTableToCsv } from "../../utils/exportTableCsv";

export default function ReplacementTable({ heading, allReplacement, loading, history, search, setSearch }) {
    const [selectedRow, setSelectedRow] = useState([]);
    const actions = (d) => {
        return (
            <div className="flex justify-content-around">
                <i className="pi pi-eye cursor-pointer text-dark" onClick={() => history(`/replacement/view/${d._id}`)}></i>
            </div>
        );
    };

    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };

    const formatDate = (date) => {
        return date?.toLocaleDateString?.("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    const dateFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e) => {
                    options.filterCallback(e.value, options.index);
                }}
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
                mask="99/99/9999"
            />
        );
    };

    const exportAll = () => {
        exportTableToCsv("replacement-orders.csv", allReplacement, [
            { header: "Order ID", value: "_id" },
            { header: "Date", value: (row) => (row.time ? formatDate(row.time) : "-") },
            { header: "Name", value: (row) => [row?.user?.firstName, row?.user?.lastName].filter(Boolean).join(" ") || "-" },
            { header: "Vehicle Number", value: (row) => row?.vehicle?.vehicleNumber || "-" },
            { header: "Status", value: "status" },
        ]);
    };

    return (
        <>
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-between mb-4">
                        <h5>{heading}</h5>
                        <div className="flex align-items-center">
                            {setSearch ? (
                                <div className="p-input-icon-left mx-2">
                                    <i className="pi pi-search" />
                                    <InputText value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" />
                                </div>
                            ) : null}
                            <Button
                                label="Export CSV"
                                icon="pi pi-download"
                                onClick={exportAll}
                                disabled={!allReplacement.length}
                                severity="success"
                            />
                        </div>
                    </div>
                    <DataTable
                        paginator
                        value={allReplacement}
                        selection={selectedRow}
                        onSelectionChange={(e) => setSelectedRow(e.value)}
                        selectionMode="checkbox"
                        showGridlines
                        filter={filters}
                        filterDisplay="menu"
                        rows={10}
                        rowsPerPageOptions={[10, 20,50, 100]}
                        loading={loading}
                        emptyMessage="No Order found."
                        className=""
                        rowClassName={(rowData) => (rowData.isNewRecord ? "p-highlight p-selectable-row" : "")}
                    >
                        <Column header="Order ID " field="_id"></Column>
                        <Column
                            field="time"
                            header="Date"
                            style={{ width: "150px" }}
                            dataType="date"
                            filterMatchMode="dateIs"
                            showFilterMatchModes={true}
                            body={(rowData) => formatDate(rowData.time)}
                            filter
                            filterElement={dateFilterTemplate}
                        ></Column>
                        {/* <Column field="user.userId" header="User Id" style={{ width: "250px" }}></Column> */}
                         <Column body={(rowData) => [rowData?.user?.firstName, rowData?.user?.lastName].filter(Boolean).join(" ") || "-"} header="Name"></Column>
                        <Column field="vehicle.vehicleNumber" header="Vehicle Number" style={{ width: "250px" }}></Column>
                        <Column field="status" header="Status"></Column>

                        <Column body={actions} style={{ width: "80px" }} header="Action"></Column>
                    </DataTable>
                </div>
            </div>
        </>
    );
}
